import { render } from "./SideNavBar.vue?vue&type=template&id=a4b6ac54&scoped=true"
import script from "./SideNavBar.vue?vue&type=script&lang=js"
export * from "./SideNavBar.vue?vue&type=script&lang=js"

import "./SideNavBar.vue?vue&type=style&index=0&id=a4b6ac54&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2784445594/src/vedicastrochart-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4b6ac54"]])

export default __exports__